export default "__VITE_ASSET__BF76Q68u__"